import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NgShortcut } from './ng-shortcut';
import { NgShortcutService } from './ng-shortcut.service';

@Directive({
  selector: '[ngShortcut]',
})
export class NgShortcutDirective implements OnInit, OnDestroy {
  @Input('ngShortcut') key: string;
  @Input() ctrlKey: boolean;
  @Input() altKey: boolean;
  @Input() shiftKey: boolean;
  @Input() priority = 0;
  @Input() preventDefault: boolean;

  private shortcutObj: NgShortcut;

  constructor(
    private elementRef: ElementRef,
    private shortcutService: NgShortcutService
  ) {}

  ngOnInit(): void {
    this.shortcutObj = new NgShortcut(this.key, this.elementRef, {
      priority: this.priority,
      altKey: this.altKey,
      shiftKey: this.shiftKey,
      ctrlKey: this.ctrlKey,
      preventDefault: this.preventDefault,
    });
    this.shortcutService.push(this.shortcutObj);
  }

  ngOnDestroy(): void {
    this.shortcutService.remove(this.shortcutObj);
  }
}
